import { decomposeColor, recomposeColor } from '@mui/material';

const GET_ALPHA_CHANNEL = 4;

export const getAlphaCompositionRGBColor = ({ primaryColor = '#fff', secondaryColor = '#fff' }) => {
  const primary = decomposeColor(primaryColor);
  const secondary = decomposeColor(secondaryColor);
  const getAlphaChannel = colorArray =>
    colorArray.length === GET_ALPHA_CHANNEL ? colorArray.pop() : 1;

  const primaryAlpha = getAlphaChannel(primary.values);
  const secondaryAlpha = getAlphaChannel(secondary.values);

  return recomposeColor({
    type: 'rgb',
    values: primary.values.map(
      (c, index) =>
        (c * primaryAlpha + secondary.values[index] * secondaryAlpha * (1 - primaryAlpha)) /
        (primaryAlpha + secondaryAlpha * (1 - primaryAlpha)),
    ),
  });
};
